// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import './assets/css/indexicon.css'
import './assets/css/font-awesome.css'
import 'mint-ui/lib/style.css'
import './assets/css/globle.css'
import echarts from 'echarts'
import Vconsole from 'vconsole'
import $ from 'jquery'
import axios from "axios"
window.onresize = setHtmlFontSize;
Vue.prototype.$echarts = echarts

axios.defaults.timeout = 5000; //请求超时的时间设定
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //axios默认的请求方式,可以自己设置
axios.defaults.baseURL = 'http://localhost:8008';
Vue.prototype.$axios = axios
let vConsole = new Vconsole()
Vue.use(vConsole)

function setHtmlFontSize() {
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();
Vue.config.productionTip = false
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js